// extracted by mini-css-extract-plugin
module.exports = {"container":"SubscriptionList_container__ob8mb","loaderContainer":"SubscriptionList_loaderContainer__3czX8"};